var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-slider"},[_c('div',{class:_vm.overlayStyle}),_c('div',{staticClass:"slider-image",style:(("background-image: url(" + _vm.curImage + ");"))})])}
var staticRenderFns = []

export { render, staticRenderFns }